app.PotentialDistrictNotes = (
    function () {
        var districtNotes = {

            Init: function () {
                app.PotentialDistrictNotes.refreshRecords();
                $("#addPotentialDistrictNote").click(function () {
                    app.PotentialDistrictNotes.showModal(null);
                });
                $(document).on("component-loading-complete",
                    function (e, component) {
                        app.PotentialDistrictNotes.ComponentLoadingComplete();
                    });
            },

            ComponentLoadingComplete: function () {
                $(".btn-edit").click(function () {
                    var rowId = $(this).closest('tr').find(':input').val();
                    app.PotentialDistrictNotes.showModal(rowId);
                });
            },

            refreshRecords: function () {
                app.page.components["PotentialDistrictNoteGrid"][0].refreshGrid();
            },

            showModal: function (rowId) {
                var url = "/Admin/District/EditPotentialDistrictNote";
                var postData = { id: rowId };
                $.ajax({
                    type: "GET",
                    url: url,
                    data: postData,
                    success: function (data) {
                        app.PotentialDistrictNotes.handleAjaxSuccess(data);
                    },
                    error: function (data) {
                        toastr.error("There was an error retrieving that note. Please try again.");
                    }
                });
            },


            handleAjaxSuccess: function (data) {
                $("#editModal").find(".modal-content").html(data);
                $("#btnSubmitEditModal").click(function () { app.PotentialDistrictNotes.createOrEditNote(event) });
                app.input.initTextAreaWithLimit(document);

                $("#btnDeletePotentialDistrictNote").click(function () {
                    event.preventDefault();
                    $("#confirmDeleteModal").modal('show');
                });
                $("#editModal").modal('show');
                app.input.initDatePicker();

                app.PotentialDistrictNotes.refreshRecords();
            },

            cancelDelete: function () {
                $("#confirmDeleteModal").modal('hide');
            },

            confirmDelete: function () {
                var rowId = $(".editItemId").val();
                var form = $('#edit-form');
                var url = "/Admin/District/DeletePotentialDistrictNote";
                var token = $('input[name="__RequestVerificationToken"]', form).val();

                var postData = { __RequestVerificationToken: token, id: rowId };
                $.ajax({
                    type: "POST",
                    url: url,
                    data: postData,
                    success: function (data) {
                        toastr.success("Deletion complete.");
                        $("#confirmDeleteModal").modal('hide');
                        $("#editModal").modal('hide');
                        app.PotentialDistrictNotes.refreshRecords();
                    },
                    error: function (data) {
                        toastr.error("There was an error deleting the potential district note. Please try again.");
                    }
                });
            },

            createOrEditNote: function (e) {


                var form = $('#edit-form');
                var formData = form.serialize();
                e.preventDefault();
                var url = "/District/EditPotentialDistrictNote";
                $.ajax({
                    type: "POST",
                    url: url,
                    data: formData,
                    success: function (data) {
                        if (data === 'success') {
                            toastr.success("Save complete.");
                            $("#editModal").modal('hide');
                            app.PotentialDistrictNotes.refreshRecords();
                        } else {
                            toastr.error("An error occurred while saving the note. Please check your entries and try again.");
                            app.PotentialDistrictNotes.handleAjaxSuccess(data);
                        }
                    },
                    error: function (data) {
                        toastr.error("There was an error saving the note. Please try again.");
                    }
                });
            }

        };

        return districtNotes;
    }()
);